<template>
  <div class="table-responsive">
    <table :id="tableid" class="table">
      <thead>
        <tr>
          <th v-for="column in todisplay" :class="column == 'description' || column == 'code' ? 'text-left' : 'text-center'" scope="col">
            {{ $t('reports.displays.' + column) }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="el in report">
          <td v-for="column in todisplay" :class="column == 'description' || column == 'code' ? 'text-left' : 'text-center'">
            <span v-if="column != 'fails'">
              {{ (column == 'details' || column == 'prioritary') ? (el[column] ? 'X' : '') : el[column] }}
            </span>
            <span v-else :title="makeToolTip(el)">
              {{ el[column ] }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'ReportCommentsDisplay',

  props: {
    report: {
      type: Array,
      required: true
    },
    todisplay: {
      type: Array,
      required: true
    },
    tableid: {
      type: String,
      required: true
    }
  },

  data: () => ({

  }),

  mounted () {
    Array.prototype.partition = function (f) {
      var matched = [],
        unmatched = [],
        i = 0,
        j = this.length

      for (; i < j; i++) {
        (f.call(this, this[i], i) ? matched : unmatched).push(this[i])
      }

      return [matched, unmatched]
    }
  },

  methods: {

    makeToolTip (el) {
      return el.fails_list.sort(this.sortCodeCallback(1)).map(x => `${x.code} ${x.description}`).join('\n')
    }
  }

}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/ReportCommentsDisplay.vue